export default {
  methods: {
    calcPurgingLoss(item) {
      const { packedMass, harvestedMass } = item;
      const result = ((harvestedMass - packedMass) / harvestedMass) * 100;
      return result;
    },
    calcDripLoss(item) {
      const { packedMass, receivedMass } = item;
      const result = ((packedMass - receivedMass) / packedMass) * 100;
      return result;
    },
    getMeatMass(processCheckSheet) {
      console.debug(processCheckSheet.length);
    },
  },
};
